<template>
    <div class="m-view_weapon">
        <h5 class="title"></h5>

        <div class="m-colection flex-between-start">
            <div class="weapon-view">
                <div class="weapon-img">
                    <img :src="require('@/assets/images/w/'+ w_list[w] +'.gif')" alt="" srcset="">

                    <div class="tips detail" v-tips="w_list[w]"></div>

                    <div class="w-name">
                        <div class="name" :class="'w-' + w"></div>
                    </div>
                </div>

                <div class="w-tab-hd flex-between-start">
                    <div class="u-btn w-btn w-0 new" :class="{'active' : w == 0}" @click="w = 0"><div class="w-img" :class="{'active' : w == 0}"></div></div>
                    <div class="u-btn w-btn w-1" :class="{'active' : w == 1}" @click="w = 1"><div class="w-img" :class="{'active' : w == 1}"></div></div>
                    <div class="u-btn w-btn w-2" :class="{'active' : w == 2}" @click="w = 2"><div class="w-img" :class="{'active' : w == 2}"></div></div>
                    <div class="u-btn w-btn w-3" :class="{'active' : w == 3}" @click="w = 3"><div class="w-img" :class="{'active' : w == 3}"></div></div>
                    <div class="u-btn w-btn w-4" :class="{'active' : w == 4}" @click="w = 4"><div class="w-img" :class="{'active' : w == 4}"></div></div>
                </div>
            </div>
            

            <div class="task-detail">
                <div class="detail-content">
                    <div class="slogen"></div>
                    <div class="task-intro">收集网页回归活动系列专属武器，相同武器仅统计一次</div>

                    <div class="gift-view">
                        <div class="reward-view flex-center-center flex-wrap">
                            <div class="list-item" v-for="(item,index) in $store.state.task[tid_weapon].subList" :key="index">
                                <div class="reward-item">
                                    <div class="icon-wrapper" :class="{'dismiss' : $store.state.task[tid_weapon].giftRate > index}">
                                        <div class="reward-pic" v-tips="item.giftList[0].giftId"><game-item :locked="true" :id="item.giftList[0].giftId" :num="item.giftList[0].sendNum"></game-item></div>
                                    </div>
                                    
                                    <div class="require">{{ $global.max_format((index + 1) , $store.state.task[tid_weapon].rate) }}/{{ index + 1 }}把</div>
                                </div>
                            </div>
                        </div>                    
                    </div>

                    <div class="u-btn apply" 
                    :class="{'dismiss' : $store.state.task[tid_weapon].giftRate == $store.state.task[tid_weapon].finishRate,
                        'disabled' : $store.state.task[tid_weapon].finishRate == 0
                    }"
                    @click="task_apply($store.state.task[tid_weapon].taskOrderId)"></div>
                </div>


                <div class="notice">温馨提醒：2026年1月1日0点后开放奖励领取</div>
            </div>
        </div>


    </div>
</template>

<style lang="scss" scoped>
.title{
    width: 557px;
    height: 56px;
    margin: 35px auto 28px;
    background-image: url(~@/assets/images/slogen-weapon.png);       
}

.m-colection{
    position: relative;
    width: 712px;
    height: 622px;
    margin: 50px auto 0;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pannel-weapon.png);

    .weapon-view{
        position: relative;
        top: 28px;
        left: 12px;
        width: 351px;
        height: 500px;
        background-image: url(~@/assets/images/view-weapon.png);
    }

    .weapon-img{
        position: relative;
        width: 351px;
        height: 500px;

        .tips{
            position: absolute;
            bottom: 100px;
            right: 20px;
            width: 42px;
            height: 103px;
            background-image: url(~@/assets/images/btn-detail.png);
            z-index: 3;
        }

        .w-name{
            position: absolute;
            top: 10px;
            left: -4px;
            width: 105px;
            height: 227px;
            z-index: 3;
            background-image: url(~@/assets/images/w/label-name.png);
            
            .name{
                position: absolute;
                left: 50%;
                top: 30px;
                transform: translateX(-43%);

                // w_list : {
                //     0 : 'HO32',
                //     1 : 'HR48',
                //     2 : 'HL78',
                //     3 : 'OJ21',
                //     4 : 'HQ72',                
                // }
                &.w-0{
                    width: 40px;
                    height: 107px;
                    background-image: url(~@/assets/images/w/name-HO32.png);
                }

                &.w-1{
                    width: 40px;
                    height: 107px;
                    background-image: url(~@/assets/images/w/name-HR48.png);
                }

                &.w-2{
                    width: 41px;
                    height: 110px;
                    background-image: url(~@/assets/images/w/name-HL78.png);
                }
                
                &.w-3{
                    width: 39px;
                    height: 109px;
                    background-image: url(~@/assets/images/w/name-OJ21.png);
                }

                &.w-4{
                    width: 39px;
                    height: 107px;
                    background-image: url(~@/assets/images/w/name-HQ72.png);
                }
            }           
        }
    }

    .w-tab-hd{
        width: 351px;

        .w-btn{
            position: relative;
            width: 69px;
            height: 68px;
            
            &::after{
                content: '';
                display: block;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                width: 100%;
                height: 100%;
                background-color: rgba($color: #000000, $alpha: 0.7);
                transition: all 0.3s;
            }

            &.active::after{
                opacity: 0;
            }

            &.new::before{
                content: '';
                display: block;
                position: absolute;
                left: 35px;
                top: -4px;
                width: 39px;
                height: 36px;
                background-image: url(~@/assets/images/icon-new_w.png);
                opacity: 1;
            }

            .w-img{
                width: 100%;
                height: 100%;
            }
            // w_list : {
            //     0 : 'HO32',
            //     1 : 'HR48',
            //     2 : 'HL78',
            //     3 : 'OJ21',
            //     4 : 'HQ72',                
            // }
            &.w-4 .w-img{
                background-image: url(~@/assets/images/w/HQ72.png);
            }
            &.w-3 .w-img{
                background-image: url(~@/assets/images/w/OJ21.png);
            }
            &.w-2 .w-img{
                background-image: url(~@/assets/images/w/HL78.png);
            }
            &.w-1 .w-img{
                background-image: url(~@/assets/images/w/HR48.png);
            }
            &.w-0 .w-img{
                background-image: url(~@/assets/images/w/HO32.png);
            }                                           
        }
    }

    .task-detail{
        position: relative;
        top: 28px;
        right: 8px;
        width: 340px;
        color: #4d2b25;

        .task-intro{            
            margin-bottom: 10px;
            font-size: 22px;
            text-align: center;
        }

        .notice{
            width: 289px;
            margin: 12px auto 0;
        }

        .gift-view{
            position: relative;
            width: 340px;
            height: 255px;
            margin: 0 auto;
            padding-top: 2px;
            box-sizing: border-box;
            background-image: url(~@/assets/images/view-wlist.png);

            .reward-item{
                margin: 0 auto 30px;
                text-align: center;
            }
        }

        .u-btn.apply{
            width: 286px;
            height: 79px;
            margin: 15px auto 0;
            background-image: url(~@/assets/images/btn-apply_w.png);
        }

        .icon-wrapper{
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 82px;
            height: 82px;
            margin: 0 10px 0;
            background-image: url(~@/assets/images/bg-item_3.png);

            .reward-pic{
                width: 69px;
                height: 69px;
            }

            &.dismiss::after{
                display: block;
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                width: 68px;
                height: 68px;
                margin: -34px 0 0 -34px;
                background-image: url(~@/assets/images/icon-dismiss.png);
                background-repeat: no-repeat;
                background-position: center center;
                pointer-events: none;
            }            
        }

    }
}
</style>

<script>
import { apiWeaponInfo,apiTaskApply  } from '@/api/index';

export default {
    data (){
        return {
            w : 0,
            w_list : {
                0 : 'HO32',
                1 : 'HR48',
                2 : 'HL78',
                3 : 'OJ21',
                4 : 'HQ72',                
            },
            tid_weapon : 'w1',
            task_info : {},
        }
    },
    mounted(){
        //this.fetch_weapon_info();
    },
    methods : {
        task_apply(){
            apiTaskApply({taskOrderId : [this.$store.state.task[this.tid_weapon].taskOrderId]})
            .then(
                res => {
                    this.$msg_modal({type : 'success' ,})
                    this.$update_evt();
                },
                rej => {
                    this.$toast(rej.message);
                },
            );
        },        
    },
}
</script>